export const moveInfoWindow = (data = {}) => {
  const {right, top, left} = data;

  const padding = 10;
  const paddingTop = 47;

  const infoWindow = document.querySelectorAll('.gm-style-iw')[0];
  const infoWindowWrap = document.querySelectorAll('.gm-style-iw-t')[0];
  const infoData = infoWindow.getBoundingClientRect();

  if (right) infoWindow.style.left = -right - padding + 'px';
  if (left) infoWindow.style.left = left + padding + 'px';
  if (top) {
    infoWindowWrap.classList.add('bottom');
    infoWindow.style.top = infoData.height + paddingTop + 'px';
  }
};
